import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@/api/client';
import { getMe } from '@/api/endpoints';
import type { Me } from '@/api/types';

/** Identity probe. `null` means "definitely not signed in" (401). */
export function useMe() {
  return useQuery<Me | null, Error>({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        return await getMe();
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 5 * 60_000,
    retry: false,
  });
}
